export const contentTypesKeys = {
  all: ['contentTypes'] as const,
  allWithCreatePermission: (indexId?: number) => [...contentTypesKeys.all, 'withCreatePermission', indexId],
  byCtName: (ctName?: string, locale?: string) => [...contentTypesKeys.all, ctName, locale] as const
};
